export default __webpack_public_path__ + "static/media/family2.2712b149.svg";